import React, { useEffect } from "react";
import "./Category_section.css";
import { Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Common_heading_holder from "../../common-components/common_heading_holder/Common_heading_holder";
import {
  getAllCategories,
  getAllSubCategory,
} from "../../../features/master/masterSlice";

const Category_section = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const category = useSelector((state) => state?.master?.categories);

  useEffect(() => {
    dispatch(getAllCategories());
  }, [dispatch]);

  const handleClick = (id) => {
    dispatch(getAllSubCategory({ category_id: id }));
    navigate(`/categories?category_id=${id}`);
  };

  const VIEW_ALL_ID = 17;

  return (
    <section className="Category_section">
      <div className="container-fluid">
        <Common_heading_holder
          heading_text={
            <>
              <span className="black-text">Our</span>
              <br />
              <span className="blue-text">Category</span>
            </>
          }
        />

        <div className="row justify-content-center">
          <div className="col-md-8">
            <Row className="custom-category-row">
              {/* DECOR BOX TOP */}
              <Col lg={2} md={6} className="mb-4">
                <div className="decor_box_holder">
                  <div className="decor-box decor-box_1"></div>
                </div>
              </Col>

              {/* LEFT SMALL CARD */}
              <Col lg={5} md={6} className="mb-4">
                {category?.[0] && (
                  <div
                    className="card-box small-card"
                    onClick={() => handleClick(category[0]?.id)}
                  >
                    <img
                      src={process.env.REACT_APP_IMG_URL + category[0]?.image}
                      alt={category[0]?.name}
                    />
                    <div className="overlay">
                      <h5>{category[0]?.name}</h5>
                    </div>
                  </div>
                )}
              </Col>

              {/* RIGHT WIDE CARD */}
              <Col lg={5} md={6} className="mb-4">
                {category?.[1] && (
                  <div
                    className="card-box wide-card"
                    onClick={() => handleClick(category[1]?.id)}
                  >
                    <img
                      src={process.env.REACT_APP_IMG_URL + category[1]?.image}
                      alt={category[1]?.name}
                    />
                    <div className="overlay">
                      <h5>{category[1]?.name}</h5>
                    </div>
                  </div>
                )}
              </Col>

              {/* BOTTOM WIDE CARD */}
              <Col lg={5} md={6} className="mb-4">
                {category?.[2] && (
                  <div
                    className="card-box wide-card"
                    onClick={() => handleClick(category[2]?.id)}
                  >
                    <img
                      src={process.env.REACT_APP_IMG_URL + category[2]?.image}
                      alt={category[2]?.name}
                    />
                    <div className="overlay">
                      <h5>{category[2]?.name}</h5>
                    </div>
                  </div>
                )}
              </Col>

              {/* VIEW ALL CARD */}
              <Col lg={5} md={6} className="mb-4">
                <div
                  className="card-box view-all-card"
                  onClick={() =>
                    navigate(`/categories`)
                  }
                >
                  <div className="overlay view-all-overlay">
                    <h5>View All Categories</h5>
                  </div>
                </div>
              </Col>

              {/* DECOR BOX BOTTOM */}
              <Col lg={2} md={6} className="mb-4">
                <div className="decor_box_holder">
                  <div className="decor-box decor-box_2"></div>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Category_section;
